import {useClickAnalytics} from '@github-ui/use-analytics'
import {useCallback} from 'react'

export function useActionsAnalytics() {
  const {sendClickAnalyticsEvent} = useClickAnalytics()
  return useCallback(
    (action: string, label: string) => {
      sendClickAnalyticsEvent({category: 'ACTIONS_WORKFLOWS', action, label})
    },
    [sendClickAnalyticsEvent],
  )
}
